import { render, staticRenderFns } from "./ednMemo.vue?vue&type=template&id=b842c570"
import script from "./ednMemo.vue?vue&type=script&lang=js"
export * from "./ednMemo.vue?vue&type=script&lang=js"
import style0 from "./ednMemo.vue?vue&type=style&index=0&id=b842c570&prod&lang=scss"


/* normalize component */
import normalizer from "!./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports